import { Box, Input, InputGroup, Icon } from '@chakra-ui/react';
import { LuSearch } from 'react-icons/lu';
import { useState, useEffect } from 'react';

import { useDebouncedSearch } from '@/utils/useDebouncedSearch';

const SearchInput = ({
  placeholder,
  value,
  onChange,
  debounced = false,
  onDebouncedChange,
}: {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  debounced?: boolean;
  onDebouncedChange?: (value: string) => void;
}) => {
  const [localValue, setLocalValue] = useState(value);
  const { debouncedOnChange } = useDebouncedSearch(localValue, onDebouncedChange || onChange, 300);

  const handleChange = (newValue: string) => {
    setLocalValue(newValue);

    if (debounced) {
      debouncedOnChange(newValue);
    } else {
      onChange(newValue);
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <Box mb={3}>
      <InputGroup
        startElement={
          <Box pl={2}>
            <Icon as={LuSearch} color="gray.400" boxSize={4} />
          </Box>
        }
      >
        <Input
          placeholder={placeholder}
          value={localValue}
          onChange={(e) => handleChange(e.target.value)}
          size="sm"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="4px"
          px={3}
          py={2}
          fontSize="14px"
          _focus={{
            borderColor: 'purple.500',
            boxShadow: '0 0 0 1px purple.500',
          }}
          _hover={{
            borderColor: 'gray.300',
          }}
        />
      </InputGroup>
    </Box>
  );
};

export default SearchInput;
